import api from "./api";

function responsePayload(response) {
  if (response?.data?.error || (response?.data?.code != null && Number(response.data.code) !== 200)) {
    throw new Error(response?.data?.message || 'Unable to load infographics.');
  }
  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export const fetchInfographicsList = (params = {}) => api.get("/infographics/list", { params }).then(responsePayload);
export const fetchInfographicDetail = (params = {}) => api.get("/infographics/detail", { params }).then(responsePayload);
export const toggleInfographicBookmark = (payload = {}) => api.post("/infographics/bookmark", payload).then(responsePayload);
export const toggleInfographicLike = (payload = {}) => api.post("/infographics/like", payload).then(responsePayload);
export const toggleInfographicRead = (payload = {}) => api.post("/infographics/mark-read", payload).then(responsePayload);
export const storeInfographicTime = (payload = {}) => api.post("/infographics/store-time", payload).then(responsePayload);
export const fetchInfographicActivity = (params = {}) => api.get("/infographics/view", { params }).then(responsePayload);
export const fetchInfographicNotes = (params = {}) => api.get("/infographics/user-notes", { params }).then(responsePayload);
export const saveInfographicNote = (payload = {}) => api.post("/infographics/save-note", payload).then(responsePayload);
export const deleteInfographicNote = (payload = {}) => api.delete("/infographics/delete-note", { data: payload }).then(responsePayload);
export const fetchInfographicReports = (params = {}) => api.get("/infographics/reports", { params }).then(responsePayload);
export const saveInfographicReport = (payload = {}) => api.post("/infographics/report", payload).then(responsePayload);
export const deleteInfographicReport = (payload = {}) => api.delete("/infographics/delete-report", { data: payload }).then(responsePayload);
